module.exports = __webpack_public_path__ + "media/src/application/media/fond_bk-d27edc949c3a8bcbafdfefcb77b122ae.png";